// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__4f08P","spinner":"Spinner_spinner__tGoFm","spinner-aib1d7":"Spinner_spinner-aib1d7__Qq6cT"};